import React from 'react'
import PaymentsContainer from 'containers/panel/admin/payments-container'
const PaymentsPage = () => {
  return (
    <PaymentsContainer/>
  )
}

export default PaymentsPage